import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';

import { from, Observable, switchMap } from 'rxjs';

import { EnvironmentType } from '../types';

@Injectable()
export class OwnHttpInterceptor implements HttpInterceptor {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    private storage: Storage;
    private environment: EnvironmentType;

    constructor(@Inject('storage') storage: Storage, @Inject('environment') environment: EnvironmentType) {
        this.storage = storage;
        this.environment = environment;
    }

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // console.log("intercepted request ... ");

        //intercept http request if request points to the api
        if (req.url.indexOf(this.environment.apiUrl) > -1) {
            const token = this.storage.get(this.environment.tokenKey);
            return from(token).pipe(
                switchMap((token: any) => {
                    // console.log(token);
                    let reqClone = null;

                    if (token && token !== null) {
                        const headers = req.headers
                            .set('Authorization', token)
                            .append('Content-Type', 'application/json');
                        reqClone = req.clone({
                            headers
                        });
                    } else {
                        reqClone = req.clone();
                    }

                    return next.handle(reqClone);
                })
            );
        } else {
            return next.handle(req);
        }
    }
}
